export default {
  "content": "<path fill=\"none\" d=\"M0 0h16v16H0z\" data-name=\"Bounding box\"/><g data-name=\"Layer 1\" fill=\"#3f4450\"><path d=\"M15.813 7.609A8.611 8.611 0 008 3 8.611 8.611 0 00.187 7.609a.833.833 0 000 .782A8.611 8.611 0 008 13a8.611 8.611 0 007.813-4.609.833.833 0 000-.782zM8 12a4 4 0 114-4 4 4 0 01-4 4z\"/><circle cx=\"8\" cy=\"8\" r=\"2\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 16 16"
  }
};